export default __webpack_public_path__ + "static/media/hiking_and_running.8ee53fa1.jpeg";